<template>
  <v-container class="max-width">
    <!-- editor -->
    <web-editor
      class="hidden-sm-and-down"
      :docCreate="docCreate"
      :copyStatus="copyStatus"
      :initial="dataItem"
      @data="save"
    ></web-editor>

    <!-- <mobile-editor
      class="hidden-md-and-up"
      :docCreate="docCreate"
      :copyStatus="copyStatus"
      :initial="dataItem"
      @data="save"
    ></mobile-editor> -->
   

    <!-- snackbar -->
    <snackbar ref="snackbar"></snackbar>
  </v-container>
</template>

<script>
import WebEditor from "../_components/web-editor.vue";
// import MobileEditor from "../_components/mobile-editor.vue";
export default {
  components: {
    WebEditor,
    // MobileEditor,
  },
  data: () => ({
    dataItem: {},
    docCreate: true,
    copyStatus: false,
  }),
  methods: {
    save(data) {
      console.log(data);
      
      data.DiscSum = 0;
      const url = "/create-stock-take";
      const self = this;
      this.$store
        .dispatch("post", { url, data })
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.$store.commit("btnLoader", false);
            self.$router.push("/stock-take");
          } else {
            self.$store.commit("btnLoader", false);
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch((err) => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
  },
};
</script>